export default __webpack_public_path__ + "static/media/SanLuis_VillaMercedes.9871e769.jpg";